import { render, staticRenderFns } from "./AppPageBody.vue?vue&type=template&id=64b4b943&scoped=true"
import script from "./AppPageBody.vue?vue&type=script&lang=js"
export * from "./AppPageBody.vue?vue&type=script&lang=js"
import style0 from "./AppPageBody.vue?vue&type=style&index=0&id=64b4b943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4b943",
  null
  
)

export default component.exports